import { NgHybridStateDeclaration } from '@uirouter/angular-hybrid';

import { ApiService }                 from '../api/api.service';
import { CompanyIntegrationsModel }   from '../companies/models/company.integrations';
import { PartstechSettingsComponent } from './partstech.settings.component';
import { SessionModel }               from '../sessions/models/session';
import { SessionService }             from '../sessions/session.service';

export const PartstechStates : Array<NgHybridStateDeclaration> = [
  {
    component: PartstechSettingsComponent,
    name     : 'app.partstech-settings',
    resolve  : [
      {
        deps     : [ ApiService ],
        resolveFn: ( apiService : ApiService ) : ng.IPromise<CompanyIntegrationsModel> => apiService.get('/company_integrations'),
        token    : 'integrations'
      },
      {
        deps     : [ SessionService ],
        resolveFn: ( sessionService : SessionService ) : ng.IPromise<SessionModel> => sessionService.refresh(),
        token    : 'session'
      }
    ],
    url: '/partstech_settings'
  }
];